<template>
  <EditModal @close="close" @commit="commit" :lang="lang">
    <div v-for="(v, k) in input" :key="k">
      <input v-model.trim="input[k]" :placeholder="v"/>
    </div>
  </EditModal>
</template>

<script>
import _ from 'lodash'
import EditModal from './EditModal.vue'
export default {
  components: {
    EditModal
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    lang: {
      type: Object,
      default () {
        return {
          title: '编辑基本信息'
        }
      }
    }
  },
  data () {
    return {
      input: _.cloneDeep(this.data)
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) }
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/modal/EditTalkModal.vue